export const APP_VERSION = "2026-05-26-pwa-cache-v4";
export const HISTORY_CACHE_SCHEMA_VERSION = 2;
